/** @prettier */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { connect } from 'react-redux';

import RadioButton, { RadioButtonOption } from '@xanadu/ui-shared/components/widgets/RadioButton';
// import PropTypes from 'prop-types';
import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';
// import { connect } from 'react-redux';
import { useReduxBridge } from '@xanadu/ui-shared/contexts/ReduxBridgeContext';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';
import { requestLanguageChange as requestLanguageChangeAct } from '@xanadu/ui-shared/modules/user/actions';

import { getClientIcons } from '../../../../../utils';

// import {
//   updateUserSitePreferences as updateUserSitePreferencesAct,
// } from '@xanadu/ui-shared/modules/dataLayer/actions';
import styles from './LanguageSelector.module.scss';

const LanguageSelector = ({
  brand,
  requestLanguageChange,
  // updateUserSitePreferences,
}) => {
  const {
    t,
    i18n: { language: activeLanguage },
  } = useImprovedTranslation();
  // this is dangerous because if the language cannot be resolved it falls back to undefined
  // const activeLanguage = i18n.resolvedLanguage;
  const { availableLanguages = [] } = useContext(ChildrenPropsContext) || {};
  const { clientName, clientSite } = useReduxBridge() || {};

  const onCountryClick = (country) => {
    requestLanguageChange(country);

    try {
      localStorage.setItem(`${brand}-ui-language`, country);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Error setting language storage item');
    }
    // updateUserSitePreferences({ key: 'language', value: country });
  };

  return (
    <div className={styles.switch}>
      <div>{t('Language')}</div>
      <RadioButton onChange={onCountryClick} value={activeLanguage} fluid type="solid">
        {availableLanguages.map((lang) => {
          const { LanguageSelectorIcon } = getClientIcons(clientName, clientSite, lang) || {};
          return (
            <RadioButtonOption
              name={`${lang}_radio_button`}
              key={lang}
              label={
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <LanguageSelectorIcon height={24} width={24} />
                  {lang.slice(3)}
                </span>
              }
              value={lang}
            />
          );
        })}
      </RadioButton>
    </div>
  );
};

LanguageSelector.propTypes = {
  brand: PropTypes.string.isRequired,
  requestLanguageChange: PropTypes.func.isRequired,
  // updateUserSitePreferences: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  requestLanguageChange: requestLanguageChangeAct,
  // updateUserSitePreferences: updateUserSitePreferencesAct,
};

function mapStateToProps(state) {
  return {
    brand: state.getIn(['application', 'brand']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
